import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import API_BASE_URL from '../config';
import FundingHero from './components/FundingHero';
import FundingStats from './components/FundingStats';
import FundingFeatured from './components/FundingFeatured';
import FundingProjectList from './components/FundingProjectList';
import { computeStats } from './fundingUtils';
import './FundingProjectsPage.css';

const FundingProjectsPage = () => {
  const allProjectsRef = useRef(null);
  const featuredRef = useRef(null);
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fundedIds, setFundedIds] = useState([]);

  const fetchIdeas = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/pitches?category=${encodeURIComponent('User/Talent')}`);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data.error || 'Failed to load student ideas.');
        setIdeas([]);
        return;
      }
      setIdeas(data.pitches || []);
    } catch (err) {
      console.error('Error loading funding ideas:', err);
      alert('Failed to load student ideas.');
      setIdeas([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchIdeas();
  }, [fetchIdeas]);

  const handleFund = (idea) => {
    if (!idea?._id) return;
    if (fundedIds.includes(idea._id)) return;
    setFundedIds((prev) => [...prev, idea._id]);
    alert(`Funding interest recorded for "${idea.fileName || 'this project'}".`);
  };

  const stats = useMemo(() => computeStats(ideas, fundedIds), [ideas, fundedIds]);

  const scrollToRef = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="funding-page">
      <FundingHero
        onExplore={() => scrollToRef(featuredRef)}
        onStartFunding={() => scrollToRef(allProjectsRef)}
      />

      <div className="funding-body">
        <FundingStats stats={stats} />

        <div ref={featuredRef}>
          {!loading && ideas.length > 0 && (
            <FundingFeatured ideas={ideas} fundedIds={fundedIds} onFund={handleFund} />
          )}
        </div>

        <div ref={allProjectsRef}>
          <FundingProjectList
            ideas={ideas}
            fundedIds={fundedIds}
            loading={loading}
            onFund={handleFund}
          />
        </div>
      </div>
    </div>
  );
};

export default FundingProjectsPage;
